import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AnimationGrid from "./components/AnimationGrid";
import AboutMe from "./components/AboutMe";
import ToolsSection from "./components/ToolsSection";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
// import LoadingScreen from "./components/LoadingScreen";
import ProjectStory from "./components/ProjectStory";

function App() {
  useEffect(() => {
    // Disable right-click
    const handleContext = (e) => {
      e.preventDefault();
    };

    // Disable common inspect/save shortcuts
    const handleKeydown = (e) => {
      // F12
      if (e.key === "F12" || e.keyCode === 123) {
        e.preventDefault();
        return;
      }

      // Ctrl+Shift+I / Ctrl+Shift+J
      if (e.ctrlKey && e.shiftKey && (e.key.toLowerCase() === "i" || e.key.toLowerCase() === "j")) {
        e.preventDefault();
        return;
      }

      // Ctrl+U (view-source), Ctrl+S (save)
      if (e.ctrlKey && (e.key.toLowerCase() === "u" || e.key.toLowerCase() === "s")) {
        e.preventDefault();
        return;
      }
    };

    // Prevent dragging images
    const handleDragStart = (e) => {
      const target = e.target;
      if (target && target.tagName === "IMG") {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContext);
    document.addEventListener("keydown", handleKeydown);
    document.addEventListener("dragstart", handleDragStart);

    return () => {
      document.removeEventListener("contextmenu", handleContext);
      document.removeEventListener("keydown", handleKeydown);
      document.removeEventListener("dragstart", handleDragStart);
    };
  }, []);
  return (
    <>
      <Routes>
        {/* HOME */}
        <Route
          path="/"
          element={
            <>
              <Navbar />
              <Hero />
              <AnimationGrid />
              <AboutMe />
              <ToolsSection />
              <Gallery />
              <Contact />
              <Footer />
            </>
          }
        />

        {/* PROJECT STORY */}
        <Route path="/projects/:slug" element={<ProjectStory />} />
      </Routes>
    </>
  );
}

export default App;
